// Gemeinsame Bausteine der Bestands-Verträge. Mengen stehen überall in Tausendstel der BASISEINHEIT des Artikels
// (1 Flasche = 1000), Mengen „im Gebinde“ in Tausendstel des genannten Gebindes (1 Kasten = 1000). Geld in Cent.
import { zId } from '@shared/ids'
import { z } from 'zod'

/** Kalendertag 'YYYY-MM-DD' (Europe/Berlin). */
export const zDay = z.iso.date({ error: 'Bitte ein gültiges Datum eingeben.' })

/** Menge im Gebinde in Tausendstel, größer als null. */
export const zUnitQty = z
  .int({ error: 'Bitte eine Menge eingeben.' })
  .min(1, { error: 'Die Menge muss größer als 0 sein.' })
  .max(1_000_000_000, { error: 'Die Menge ist zu groß.' })

/** Menge im Gebinde in Tausendstel, null erlaubt („nichts angekommen“). */
export const zUnitQtyOrZero = z
  .int({ error: 'Bitte eine Menge eingeben.' })
  .min(0, { error: 'Die Menge darf nicht negativ sein.' })
  .max(1_000_000_000, { error: 'Die Menge ist zu groß.' })

export const zReason = z
  .string({ error: 'Bitte geben Sie einen Grund an.' })
  .trim()
  .min(3, { error: 'Bitte geben Sie einen Grund an (mindestens 3 Zeichen).' })
  .max(500)

export const zNote = z.string().trim().max(500).nullish()

/** Gebinde eines Artikels für Anzeige und Umrechnung. */
export const zUnitInfo = z.object({
  id: zId,
  /** Einheitencode: 'bottle', 'crate' … */
  code: z.string(),
  /** Kurzform: „Ka“ */
  short: z.string(),
  /** Basismenge je Gebinde in Tausendstel (Kasten mit 20 Flaschen = 20000) */
  baseQty: z.int(),
})
export type UnitInfo = z.output<typeof zUnitInfo>

export const zLocationRef = z.object({ id: zId, code: z.string(), name: z.string(), kind: z.string() })
export type LocationRef = z.output<typeof zLocationRef>

/** Belegverweis einer Bewegung oder Aufgabe. */
export const zDocumentRef = z.object({
  id: zId,
  type: z.string(),
  typeTitle: z.string(),
  number: z.string().nullable(),
})

export const zPerson = z.object({ id: zId, name: z.string() })

/** Antwort der Aktionen, die einen Beleg entweder buchen oder zur Freigabe stellen. */
export const APPROVAL_OUTCOMES = ['posted', 'pending'] as const
